import SalesGoalsAPI from '../../api/salesGoals';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getSalesGoals: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getSalesGoalById: $state => id => {
    return $state.records.find(record => record.id === Number(id));
  },
};

export const actions = {
  get: async ({ commit }, params = {}) => {
    commit('setUIFlag', { isFetching: true });
    try {
      const response = await SalesGoalsAPI.get(params);
      commit('setRecords', response.data.sales_goals || response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  create: async ({ commit }, data) => {
    commit('setUIFlag', { isCreating: true });
    try {
      const response = await SalesGoalsAPI.create(data);
      commit('addRecord', response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('setUIFlag', { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...data }) => {
    commit('setUIFlag', { isUpdating: true });
    try {
      const response = await SalesGoalsAPI.update(id, data);
      commit('updateRecord', response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('setUIFlag', { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit('setUIFlag', { isDeleting: true });
    try {
      await SalesGoalsAPI.delete(id);
      commit('removeRecord', id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('setUIFlag', { isDeleting: false });
    }
  },
};

export const mutations = {
  setRecords($state, records) {
    $state.records = records;
  },

  addRecord($state, record) {
    $state.records.push(record);
  },

  updateRecord($state, record) {
    const index = $state.records.findIndex(r => r.id === record.id);
    if (index !== -1) {
      $state.records[index] = record;
    }
  },

  removeRecord($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },

  setUIFlag($state, uiFlag) {
    $state.uiFlags = { ...$state.uiFlags, ...uiFlag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
